var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrhh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.6667H0.666667C0.489856 13.6667 0.320286 13.5965 0.195262 13.4714C0.0702379 13.3464 0 13.1769 0 13V1.00004C0 0.82323 0.0702379 0.65366 0.195262 0.528636C0.320286 0.403612 0.489856 0.333374 0.666667 0.333374H11.3333C11.5101 0.333374 11.6797 0.403612 11.8047 0.528636C11.9298 0.65366 12 0.82323 12 1.00004V13C12 13.1769 11.9298 13.3464 11.8047 13.4714C11.6797 13.5965 11.5101 13.6667 11.3333 13.6667ZM10.6667 12.3334V1.66671H1.33333V12.3334H10.6667ZM2.66667 3.00004H5.33333V5.66671H2.66667V3.00004ZM2.66667 7.00004H9.33333V8.33337H2.66667V7.00004ZM2.66667 9.66671H9.33333V11H2.66667V9.66671ZM6.66667 3.66671H9.33333V5.00004H6.66667V3.66671Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrhh);
export default __webpack_public_path__ + "static/media/rrhh.dd3989ea3b521cd67cb78fd4b815365f.svg";
export { ForwardRef as ReactComponent };